import Framework7 from "framework7"

export const BREAK_LINE = Framework7.device.cordova ? '\n' : '%0D%0A'